export const SOCIAL_NETWORKS = {
  FACEBOOK: 'https://www.facebook.com/groziostudijaramioda',
  INSTAGRAM: 'https://www.instagram.com/rami__oda/',
  TIKTOK: 'https://www.tiktok.com/@rami__oda',
};

export const LINKS = {
  HOME: '/',
  SERVICES: '/paslaugos',
  ABOUT: '/apie',
  ABOUT_RAMINTA: '/apie/raminta-tamulaite',
  ABOUT_LORETA: '/apie/loreta-vysniauskaite',
  BOOKING: '/rezervacija',
  PRICES: '/kainos',
  CONTACTS: '/kontaktai',
  GIFT_CARD: '/dovanu-kuponas',
  ONLINE_TEST: '/odos-testas',
  BLOG: '/straipsniai',
  PRODUCTS: '/produktai',
  PT: '/pirkimo-taisykles',
  PPP: '/privatumo-politika',
  COOKIES: '/slapuku-politika',
  GS: '/grazinimo-salygos',
  PS: '/prekiu-pristatymas',
  SALE: '/produktai-su-nuolaida',
  VEIDO_PRIEZIURA: '/c/produktai/veido-prieziura/',
  KUNO_PRIEZIURA: '/c/produktai/kuno-prieziura/',
  DEKORATYVINE: '/c/dekoratyvine-kosmetika/',
  FEATURED: '/perkamiausi-produktai',
  CHECKOUT: '/uzsakymas',
  LOGIN: '/prisijungimas',
  REGISTER: '/registracija',
  PASSWORD_REMINDER: '/slaptazodzio-priminimas',
  PASSWORD_RESET: '/slaptazodzio-keitimas',
  ACCOUNT: '/paskyra',
  LOYALTY_PROGRAM: '/lojalumo-programa',
  LED_MASK: '/led-veido-kauke',
  BRANDS: '/c/gamintojas/',
};

export const CONTACTS = {
  SALON_TITLE: '„Rami oda“',
  SALON_FACEBOOK: 'https://www.facebook.com/groziostudijaramioda/',
  SALON_ADDRESS: 'Kęstučio g. 27-115, Kaunas',
  SALON_MAP: 'https://maps.app.goo.gl/fVzS8XR5ak8m4dXN9',
  EMAIL: 'info@ramioda.lt',
  PHONE: '+370 629 08590',
  TREATWELL: 'https://book.treatwell.lt/salonas/rami-oda/',
};

export const FEATURED_IN = {
  MIN: 'https://www.15min.lt/gyvenimas/naujiena/grozis/kovoje-su-akne-kosmetologes-patarimai-padesiantys-pagerinti-odos-bukle-1062-1899758',
  MOTERIS:
    'https://www.moteris.lt/lt/grozis/g-74970-kovoje-su-akne-kosmetologes-patarimai-padesiantys-pagerinti-odos-bukle',
  VE: 'https://ve.lt/gyvenimas/sveikata/kovoje-su-akne-kosmetologes-patarimai-padesiantys-pagerinti-odos-bukle',
  LRT: 'https://www.lrt.lt/naujienos/gyvenimas/13/1735159/kosmetologe-pataria-kaip-kovoti-su-akne-kas-turi-buti-priemones-sudetyje-o-kas-padaro-daugiausia-zalos',
  ALFA: 'https://www.alfa.lt/gyvenimas/sveikata/kova-su-akne-kosmetologes-patarimai-padesiantys-pagerinti-odos-bukle/259479/',
};

/**
 * The WooCommerce category "Prekės ženklas", whose children are the brands.
 *
 * Brand pages are no longer listed by hand: the navigation reads the child terms from
 * WordPress, and a product finds its own brand page by looking for the category with
 * this parent. See src/components/Navigation/BrandsMenu.tsx.
 */
export const BRAND_CATEGORY_ID = 708;

export const FACE_CARE = {
  MAIN: '/c/produktai/veido-prieziura/',
  PRAUSIKLIAI: '/c/produktai/veido-prieziura/prausiklis/',
  SERUMAI: '/c/produktai/veido-prieziura/serumas/',
  AMPULES: '/c/produktai/veido-prieziura/veido-ampules/',
  KREMAI: '/c/produktai/veido-prieziura/kremas/',
  SPF: '/c/produktai/veido-prieziura/apsauga-nuo-saules/',
  KAUKE: '/c/produktai/veido-prieziura/veido-kauke/',
  VALIKLIS: '/c/produktai/veido-prieziura/makiazo-valiklis/',
  PAAKIAI: '/c/produktai/veido-prieziura/paakiu-odos-prieziura/',
  SPUOGAI: '/c/produktai/veido-prieziura/priemone-nuo-spuogu/',
  SVEITIKLIS: '/c/produktai/veido-prieziura/sveitiklis/',
  TONIKAS: '/c/produktai/veido-prieziura/tonikas/',
  KITA: '/c/produktai/veido-prieziura/kita/',
  LUPOS: '/c/produktai/veido-prieziura/lupu-prieziura/',
  SOS: '/c/produktai/veido-prieziura/sos-priemones/',
};

export const BODY_CARE = {
  MAIN: '/c/produktai/kuno-prieziura/',
  DUSAS: '/c/produktai/kuno-prieziura/duso-geliai-ir-putos/',
  ALIEJAI: '/c/produktai/kuno-prieziura/kuno-aliejai/',
  KREMAI: '/c/produktai/kuno-prieziura/kuno-kremai-ir-geliai/',
  PLAUKAMS: '/c/produktai/kuno-prieziura/plaukams/',
  PRAUSIKLIS: '/c/produktai/kuno-prieziura/prausikliai-ir-sveitikliai/',
  CELIULITAS: '/c/produktai/kuno-prieziura/priemones-nuo-celiulito/',
  SPF: '/c/produktai/kuno-prieziura/kuno-apsauga-nuo-saules/',
};

export const OTHER = {
  RINKINIAI: '/c/produktai/kosmetikos-rinkiniai/',
  PAPILDAI: '/c/produktai/maisto-papildai-produktai/',
};

export const SKIN_TYPE = {
  NORMAL_SKIN: '/c/odos-tipai/normali-oda/',
  DRY_SKIN: '/c/odos-tipai/sausa-oda-odos-tipai/',
  OIL_SKIN: '/c/odos-tipai/riebi-oda/',
};

export const SKIN_CONDITION = {
  ACNE: '/c/odos-bukle/akne/',
  BRANDI: '/c/odos-bukle/brandi-oda/',
  DEHIDRUOTA: '/c/odos-bukle/dehidratuota-oda/',
  DERMATITAS: '/c/odos-bukle/dermatitas-egzema/',
  JAUTRI: '/c/odos-bukle/jautri-oda/',
  PIGMENTACIJA: '/c/odos-bukle/pigmentacija/',
  ROZINE: '/c/odos-bukle/raustanti-oda-rozine-odos-bukle/',
  SENSTANTI: '/c/odos-bukle/senstanti-oda/',
};

export const DECORATIVE = {
  MAIN: '/c/dekoratyvine-kosmetika/',
  EYES: '/c/dekoratyvine-kosmetika/akims/',
  BB_CC: '/c/dekoratyvine-kosmetika/bb-cc-kremai/',
  TOOLS: '/c/dekoratyvine-kosmetika/irankiai-ir-priedai/',
  LIPS: '/c/dekoratyvine-kosmetika/lupoms/',
  MAKEUP_BASE: '/c/dekoratyvine-kosmetika/makiazo-baze/',
  MAKEUP_TOP: '/c/dekoratyvine-kosmetika/makiazo-pagrindas/',
  MASKAVIMO: '/c/dekoratyvine-kosmetika/maskavimo-priemone/',
  SAUSA_PUDRA: '/c/dekoratyvine-kosmetika/sausos-birios-pudros/',
  IDEGIS: '/c/dekoratyvine-kosmetika/savaiminis-idegis/',
  SKAISTALAI: '/c/dekoratyvine-kosmetika/skaistalai-bronzantai/',
  DULKSNA: '/c/dekoratyvine-kosmetika/veido-dulksna/',
  SEPETELIAI: '/c/dekoratyvine-kosmetika/veido-sepeteliai/',
  RINKINIAI: '/c/dekoratyvine-kosmetika/dekoratyvines-kosmetikos-rinkiniai/',
};

/**
 * Brands whose price and buy button are hidden until the customer has had a
 * consultation (see src/utils/hooks/useConsultationUnlock.ts).
 *
 * Lives here rather than in the hook because the product structured data needs it at
 * build time, and must not pull a React module in to get it.
 */
export const CONSULTATION_BRANDS = [
  'Environ',
  'Noon Aesthetics',
  'Synergie Skin',
  'SeboCalm',
];

export const DISCOUNT_CODES = {
  NEWSLETTER: 'sveikiatvyke',
  GIFT_CARD_PURCHASERS: 'pasilepinkite',
  WELCOME: 'ramioda15',
};

export const SERVICES = {
  VEIDO_VALYMAS: '/paslaugos/veido-valymas/',
  ANTAKIAI: '/paslaugos/antakiu-ir-blakstienu-dizainas/',
  MAKIAZAS: '/paslaugos/makiazas/',
  RAMI_ODA: '/paslaugos/prabangi-rami-oda-veido-procedura/',
  DREKINANTI: '/paslaugos/drekinanti-veido-procedura/',
  MASAZAS: '/paslaugos/veido-masazas/',
  JAUNINANTI: '/paslaugos/jauninanti-veido-procedura/',
  SVENTE: '/paslaugos/veido-procedura-pries-svente/',
  DEPILIACIJA: '/paslaugos/veido-depiliacija/',
  LED: '/paslaugos/led-fototerapija-dermalux-aparatu/',
};

export const SHIPPING = {
  THRESHOLD_AMOUNT: 59,
  /**
   * The only country the store ships to, and the only one its shipping zone covers.
   *
   * WooCommerce costs a package against the customer's shipping country: a country
   * that matches no zone returns no rates at all, so the checkout has nothing to
   * offer. The form collects no country, so this is what it means implicitly.
   */
  COUNTRY: 'LT',
  OMNIVA: 'omnivalt_pt',
  OMNIVA_PRICE: '3,29',
  // Shown struck through beside OMNIVA_PRICE once the basket clears the threshold.
  FREE_PRICE: '0,00',
  PICKUP_PRICE: '0,00',
  PICKUP: 'local_pickup:7',
  // CARRIER: 'flat_rate:6',
};

/**
 * Free personalised gift, awarded once the basket clears the threshold. Kept apart
 * from SHIPPING because it is a separate promise with its own, higher bar.
 */
export const FREE_GIFT = {
  THRESHOLD_AMOUNT: 95,
};

/**
 * Product suggestions shown under the cart drawer's shipping/gift progress bars, priced
 * just above the remaining gap so adding one closes it. Ceiling keeps a small gap (e.g.
 * €7) from surfacing an unrelated, much pricier product.
 */
export const GAP_SUGGESTIONS = {
  PRICE_CEILING_OVER_GAP: 15,
  // Below this, a customer has barely started shopping — a nudge toward a threshold
  // that's still tens of euros away reads as random rather than helpful.
  MIN_CART_TOTAL: 24,
  SHIPPING_COPY: 'Pridėkite šiuos produktus ir gaukite nemokamą pristatymą',
  GIFT_COPY: 'Pridėkite šiuos produktus ir gaukite dovaną',
};

/**
 * Checkout's suggested-products panel ("Jūsų odai taip pat tiktų"), sourced primarily
 * from the cross-sell products configured on whatever is currently in the basket.
 * These are the fallback shown — and topped up to — when that yields fewer than
 * MAX_SHOWN eligible suggestions: an empty basket, basket items with no cross-sell
 * configured, or every related product already owned.
 */
export const CHECKOUT_SUGGESTIONS = {
  FALLBACK_PRODUCT_IDS: [2471, 2738],
  MAX_SHOWN: 2,
};

/**
 * The first-purchase pop-up (see src/components/MarketingDialog). The coupon behind
 * DISCOUNT_CODES.WELCOME is configured in WooCommerce with the same minimum, so the
 * fine print and the checkout cannot drift apart.
 */
export const WELCOME_OFFER = {
  /** Order the tiles are shown in — a GraphQL `in` filter does not preserve it. */
  PRODUCT_IDS: [1344, 2760, 13078],
  MIN_ORDER_AMOUNT: 100,
  DISCOUNT_PERCENT: 15,
  /** Long enough to let the visitor start reading the page before interrupting. */
  DELAY_MS: 8000,
  DISMISS_HOURS: 48,
};

/**
 * Loyalty programme configuration. Everything tunable about points lives here so no
 * component has to hardcode a rate, a status, or a threshold.
 */
export const LOYALTY = {
  /** 1 € spent = 1 point. */
  POINTS_PER_EURO: 1,
  /**
   * Statuses whose money is actually collected. Deliberately narrower than
   * isActiveOrderStatus(), which includes PENDING and ON_HOLD: an unpaid order must
   * never award points that later have to vanish.
   */
  QUALIFYING_STATUSES: ['PROCESSING', 'COMPLETED'],
  /**
   * One page is enough for this shop, and it keeps the section to a single request.
   * A customer past this many paid orders would see an understated derived balance.
   */
  ORDERS_QUERY_LIMIT: 100,
  /**
   * false → the balance is derived from paid order history.
   * true  → `viewer { userFields { loyaltyPoints } }` is authoritative.
   *
   * True, because points are not only earned by spending — the admin also awards them
   * by hand in the ACF field, and a derived balance is blind to that. The cost is that
   * anyone the admin has not seeded reads 0 until they are, which is the correct
   * answer for them anyway: the field, not order history, is the ledger.
   */
  USE_SERVER_BALANCE: true,
};

/**
 * Products redeemable with points, cheapest first.
 *
 * Hardcoded by databaseId on purpose (see the plan): there is no backend source for a
 * reward catalogue, and adding one is not worth it for thirteen entries. The product
 * itself — name, image, price, stock — is fetched at runtime, so only the pairing
 * lives here.
 *
 * Points are curated, not derived from a formula — there is no published point→euro
 * rate (see the plan). Originally roughly 17–28 points per €1 of retail for the
 * regular rungs, jumping to ~52x for the flagship; all raised 25% on top of that
 * (Rom's call — the ladder read as too easy to climb) and rounded to the nearest 5, so
 * the ladder still reads as "cheap first gift up to aspirational reward" even though
 * nothing here is computed. 2026-09-10: five entries swapped for equivalent products
 * (Rom's call) and three added, priced the same way against their current retail price.
 *
 * If `allWpSimpleProduct` in the `LoyaltyProgramPage` query
 * (src/pages/lojalumo-programa.tsx) ever stops matching these ids, update both by hand.
 */
export const LOYALTY_REWARDS: ReadonlyArray<{
  productId: number;
  points: number;
}> = [
  { productId: 2471, points: 100 }, // Endocare Essential koncentratas, 1x1 ml
  { productId: 9925, points: 165 }, // HubisLab E+ Epiderma Nova Cell raminanti veido kaukė, 1 vnt.
  { productId: 14602, points: 240 }, // Biretix Isorepair lūpų balzamas, 10 ml
  { productId: 2617, points: 375 }, // Endocare Hydractive micelinis vanduo, 400 ml
  { productId: 4868, points: 565 }, // Ahava Clineral X-Zem rankų kremas, 125 ml
  { productId: 11225, points: 600 }, // Skin Resist Velvet veido prausiklis, 200 ml
  { productId: 2886, points: 715 }, // Thesera Hydrating Repair veido kremas, 20 ml
  { productId: 10051, points: 815 }, // Biretix Double Correction serumas, 30 ml
  { productId: 2738, points: 875 }, // Heliocare 360 Water gelis SPF50+ (be spalvos), 50 ml
  { productId: 3023, points: 1375 }, // Endocare Radiance C Ferulic Edafence® serumas, 30 ml
  { productId: 1870, points: 1680 }, // Noon Igloo Mask veido kaukė, 70 g
  { productId: 2480, points: 2000 }, // Endocare Renewal retinolio serumas 0.2%, 30 ml
  { productId: 1622, points: 6380 }, // Noon Retinol Charisma 0.3% serumas su retinoliu, 40 ml
];

/**
 * Wishlist configuration.
 *
 * Saved product ids live as a single JSON-encoded customer meta value under
 * META_KEY, written via the `updateCustomer` mutation's `metaData` input —
 * there is no dedicated wishlist mutation or ACF field on this backend.
 */
export const WISHLIST = {
  META_KEY: 'wishlist_product_ids',
  /** A customer past this count would blow past the section's single request. */
  MAX_ITEMS: 10,
};
